import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import userStorage from 'utilities/user/userStorage';
import { AuthenticatedRoutesHandler } from 'shared/routes/AuthenticatedRoutesHandler';
import { PublicRoutesHandler } from 'shared/routes/PublicRoutesHandler';
import { ErrorFallback } from 'shared/pages/errorFallback/ErrorFallback';
import raygun from 'utilities/externalServices/raygun/raygun.config';

export function App() {
  const history = useHistory();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(Boolean(userStorage.getUser()));

  useEffect(() => {
    history.listen(() => {
      setIsLoggedIn(Boolean(userStorage.getUser()));
    });
  }, []);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      resetKeys={[location.pathname]}
      onReset={() => history.push('/dashboard')}
      onError={(err) => raygun.logError(err)}
    >
      {isLoggedIn ? <AuthenticatedRoutesHandler /> : <PublicRoutesHandler />}
    </ErrorBoundary>
  );
}
